import { render } from "./TableCalendarModalEvents.vue?vue&type=template&id=3848189f&ts=true"
import script from "./TableCalendarModalEvents.vue?vue&type=script&lang=ts"
export * from "./TableCalendarModalEvents.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__